import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	CreateSeamlessRegistrationRequest,
	SeamlessRegistrationPayload,
	SeamlessRegistrationReferenceResponse,
	SeamlessRegistrationResponse,
} from "./seamless-registration.model";

export const ACTION_PREFIX = "[Seamless Registration]";

export const SEAMLESS_REGISTRATION_ACTION_TYPE = {
	initializeRegistration: `${ACTION_PREFIX} Initialize Registration`,
	initializeRegistrationSuccess: `${ACTION_PREFIX} Initialize Registration Success`,
	initializeRegistrationFail: `${ACTION_PREFIX} Initialize Registration Fail`,

	getRegistrationState: `${ACTION_PREFIX} Get Registration State`,
	getRegistrationStateSuccess: `${ACTION_PREFIX} Get Registration State Success`,
	getRegistrationStateFail: `${ACTION_PREFIX} Get Registration State Fail`,

	createRegistration: `${ACTION_PREFIX} Create Registration`,
	createRegistrationSuccess: `${ACTION_PREFIX} Create Registration Success`,
	createRegistrationFail: `${ACTION_PREFIX} Create Registration Fail`,

	attachBonus: `${ACTION_PREFIX} Attach Bonus`,
	attachBonusSuccess: `${ACTION_PREFIX} Attach Bonus Success`,
	attachBonusFail: `${ACTION_PREFIX}  Attach Bonus Fail`,

	stopPolling: `${ACTION_PREFIX} Stop Polling ${SYNC_SUFFIX}`,
	resetSeamlessRegistration: `${ACTION_PREFIX} Reset Seamless Registration ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class SeamlessRegistrationAction {
	initializeRegistration(payload: SeamlessRegistrationPayload): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.initializeRegistration,
			payload,
		};
	}

	initializeRegistrationSuccess(payload: SeamlessRegistrationReferenceResponse): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.initializeRegistrationSuccess,
			payload,
		};
	}

	initializeRegistrationFail(error: AppError | Error): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.initializeRegistrationFail,
			payload: error,
		};
	}

	getRegistrationState(): Action {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.getRegistrationState,
		};
	}

	getRegistrationStateSuccess(payload: SeamlessRegistrationResponse): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.getRegistrationStateSuccess,
			payload,
		};
	}

	getRegistrationStateFail(error: AppError | Error): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.getRegistrationStateFail,
			payload: error,
		};
	}

	createRegistration(payload: CreateSeamlessRegistrationRequest): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.createRegistration,
			payload,
		};
	}

	createRegistrationSuccess(): Action {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.createRegistrationSuccess,
		};
	}

	createRegistrationFail(error: AppError | Error): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.createRegistrationFail,
			payload: error,
		};
	}

	stopPolling(): Action {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.stopPolling,
		};
	}

	resetSeamlessRegistration(): Action {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.resetSeamlessRegistration,
		};
	}

	attachBonus(siteTrackingId: string): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.attachBonus,
			payload: siteTrackingId,
		};
	}

	attachBonusSuccess(): Action {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.attachBonusSuccess,
		};
	}

	attachBonusFail(error: AppError | Error): ActionWithPayload {
		return {
			type: SEAMLESS_REGISTRATION_ACTION_TYPE.attachBonusFail,
			payload: error,
		};
	}
}
